function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.3079 0L0 12.285L3.21773 15.4967L15.5256 3.21174L12.3079 0Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.5256 27.7816L18.7434 30.9933L27.8335 21.9201L36.9237 30.9933L40.1414 27.7817V27.7814L27.8335 15.4966L15.5256 27.7816Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.7434 0L15.5256 3.21174L27.8335 15.4967L31.0513 12.285L18.7434 0Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 18.7083L12.3079 30.9933L15.5256 27.7816L3.21773 15.4966L0 18.7083Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.2558 15.3453C34.4239 15.3453 34.5377 15.2533 34.5377 15.1073C34.5377 14.9557 34.4239 14.8746 34.2558 14.8746H33.9306V15.3453H34.2558ZM33.5455 14.5173H34.2989C34.6839 14.5173 34.917 14.7663 34.917 15.1071C34.917 15.3831 34.7761 15.5616 34.4886 15.6428L35.2205 16.5356H34.7599L34.0496 15.6752H33.9304V16.5356H33.5455V14.5173ZM35.7958 15.5292C35.7958 14.6473 35.0693 13.9277 34.1857 13.9277C33.3128 13.9277 32.5865 14.6473 32.5865 15.5292C32.5865 16.4113 33.3128 17.131 34.1857 17.131C35.0693 17.131 35.7958 16.4113 35.7958 15.5292ZM32.2014 15.5292C32.2014 14.4362 33.0958 13.5435 34.1855 13.5435C35.286 13.5435 36.1805 14.4362 36.1805 15.5292C36.1805 16.6222 35.286 17.515 34.1855 17.515C33.0958 17.515 32.2014 16.6222 32.2014 15.5292Z",
  fill: "white"
});

function SvgWhiteAlvaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 31,
    viewBox: "0 0 41 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteAlvaLogo);
export default __webpack_public_path__ + "static/media/whiteAlvaLogo.b8cb8a695756ff57edc9f565d26dd9b6.svg";
export { ForwardRef as ReactComponent };